import { useEffect } from "react";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Home } from "./pages/home/home";
import { Contact } from "./pages/contact/contact";
import { animationDelayGenerator } from "./utils/animation-delay";
import { ContactProvider } from "./state/contact";
import { TermsOfUse } from "./pages/terms-of-use";
import { PrivacyPolicy } from "./pages/privacy-policy";
import { HelmetProvider } from "react-helmet-async";
import { FAQs } from "pages/faqs";
import { RefundPolicy } from "pages/refund-policy";
import { CCPApp } from "pages/ccpapp";
import { USPrivacy } from "pages/us-privacy";
import { Cookies } from "pages/cookies";

export const routes = [
    {
        path: "/",
        element: <Home />,
        name: "Home"
    },
    {
        path: "/contact/",
        element: <Contact />,
        name: "Contact",
    },
    {
        path: "/faqs/",
        element: <FAQs />,
        name: "FAQ's",
    },
    {
        path: "/terms/",
        element: <TermsOfUse />,
    },
    {
        path: "/privacy/",
        element: <PrivacyPolicy />,
    },
    {
        path: "/refund-policy/",
        element: <RefundPolicy />,
    },
    {
        path: "/legal/ccpapp/",
        element: <CCPApp />,
    },
    {
        path: "/legal/us-privacy/",
        element: <USPrivacy />,
    },
    {
        path: "/cookies/",
        element: <Cookies />,
    },
];


const router = createBrowserRouter(routes);

const gen = animationDelayGenerator({});
export var nextDelay = () => gen.next().value;
export const resetNextDelay = () => nextDelay = () => {
};

const future = { v7_startTransition: true, v7_relativeSplatPath: true };

export const App = () => {
    useEffect(resetNextDelay, []);
    return (
        <HelmetProvider>
            <ContactProvider>
                <RouterProvider router={router} future={future} />
            </ContactProvider>
        </HelmetProvider>
    );
};

